import { css } from '@emotion/react';

export const styles = {
  wrapper: css`
    position: sticky;
    top: 100px;

    padding: 24px;
    border: 1px solid #ececf2;
    border-radius: 24px;
    background: #ffffff;

    display: flex;
    flex-direction: column;
    gap: 28px;
  `,

  group: css`
    display: flex;
    flex-direction: column;
    gap: 12px;

    h4 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #6b7280;
    }
  `,

  chips: css`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  `,

  chip: css`
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid #e6e8ef;

    background: #ffffff;
    color: #1f1f1f;

    font-size: 14px;
    cursor: pointer;

    transition: all 0.2s ease;

    &:hover {
      border-color: #6c3bff;
    }
  `,

  active: css`
    border-color: #6c3bff;
    background: rgba(108, 59, 255, 0.08);
    color: #6c3bff;
  `,
};
